import React,{useEffect,useState} from "react";
import {Switch,Route,Redirect} from "react-router-dom";
import Navbar from "./Navbar";
import Signup from "./signup";
import Login from "./login";
import Dash from "./dashboard";
import Resource from "./Resource";
import Home from "./Home";
import About from "./About";
import Footer from "./Footer";
import {auth} from "./firebase/firebase.js"

const App=()=>{
    var unSub=()=>{};
    const [authUser, setauthUser] = useState(null)
    useEffect(() => {
        let patja="JK";
       var unSub= auth().onAuthStateChanged(user=>{
            if (user) {
                setauthUser(user)
            } else {
                setauthUser(null)
            }
        })

        return(()=>{
            unSub();
        })

    })
    return (
        <>
        <Navbar user={authUser}/>
        <Switch>
        <Route exact path="/"><Home /></Route>
        <Route exact path="/about"><About /></Route>
        <Route exact path="/signup"><Signup user={authUser} /></Route> 
        <Route exact path="/login"><Login user={authUser} /></Route>
        <Route exact path="/dashboard"> <Dash user={authUser} /></Route>
        <Route exact path="/Resource"> <Resource /></Route>
        <Redirect to="/" />
        </Switch>
        <Footer />
        </>
    );
}

export default App;